import Vue from "vue/dist/vue.esm.js";
import router from "./router";
import store from "./store";

// 提供跨浏览器的高度一致性
import "normalize.css";

// 引入ant-design
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
Vue.use(Antd);

// 引入vue-cookies
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

// 引入vxe-table
import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/index.css";
import VXETablePluginAntd from "vxe-table-plugin-antd";
import "vxe-table-plugin-antd/dist/style.css";
Vue.use(VXETable);
VXETable.use(VXETablePluginAntd);

//引入echarts图表
import echarts from "echarts";
Vue.prototype.$echarts = echarts;

// 引入项目全局样式
import "./assets/styles/index.scss";

// 引入图标样式
import "./assets/icon/iconfont.scss";

// 注册工具类
import "./utils";

// 注册时间工具
import moment from "moment";
// 挂载到原型
Vue.prototype.$moment = moment;

// 注册全局组件
import "./components";
import "./assets/iconfont/iconfont.js";
import "./assets/iconfont/icon.css";
// 全局混入
import "./mixins/global";
Vue.config.productionTip = false;
import App from "./App.vue";
new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount("#app");
//右键单击出现的菜单
import contentmenu from "v-contextmenu";
import "v-contextmenu/dist/index.css";
Vue.use(contentmenu);
